import React from 'react';
import translate from '../../../commonComponents/translate';
import OrderCreateSummary from './OrderCreateSummary';
import AddNoteOrder from './AddNoteOrder';

function OrderCreateFooter(props) {
  return (
    <div
      id="orderCreateFooter"
      className="order-footer-wrapper m-portlet m-portlet--mobile"
    >
      <AddNoteOrder {...props} />
      <OrderCreateSummary {...props} />
    </div>
  );
}

OrderCreateFooter.propTypes = {};

export default translate(OrderCreateFooter);
